import { Button, Modal } from "antd";
import React from "react";


export default function PopUpMsg({ visible, titulo, contenido, alCerrar }){


    return (<Modal styles={{
        content: titulo === "" ? {
            background: 'rgba(0, 0, 0, 0.3)',
            color: 'white',
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'right',            
        } : {}
    }} title={<h1 style={{textAlign:'center'}}>{titulo}</h1>} open={visible} onCancel={alCerrar} destroyOnClose={true}                
                footer={[<Button style={{marginTop:'20px',}} key="back" onClick={alCerrar}>X</Button>]} 
                style={{ height: '90vh'}}               
            >
                <div style={{fontSize: 18}}>{contenido}</div>
            </Modal>)
}